export default __webpack_public_path__ + "static/media/new-ai-logo-black.4673507d.svg";